import { IconsProps } from '@/types/shared'
import React from 'react'

const EditCirleIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                width="18"
                height="17"
                viewBox="0 0 18 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect
                    x="0.606445"
                    y="0.582397"
                    width="16.4213"
                    height="16.4213"
                    rx="8.21064"
                    fill="#0D47A0"
                />
                <path
                    d="M5.43666 12.1739H6.12491L10.846 7.45277L10.1578 6.76453L5.43666 11.4856V12.1739ZM4.4707 13.1398V11.0872L10.846 4.72394C10.9426 4.63539 11.0493 4.56697 11.166 4.51867C11.2827 4.47038 11.4055 4.44623 11.5343 4.44623C11.6631 4.44623 11.7878 4.47038 11.9086 4.51867C12.0293 4.56697 12.134 4.63942 12.2225 4.73602L12.8866 5.41219C12.9832 5.50073 13.0536 5.60538 13.0979 5.72612C13.1422 5.84687 13.1643 5.96761 13.1643 6.08836C13.1643 6.21715 13.1422 6.33991 13.0979 6.45663C13.0536 6.57335 12.9832 6.68 12.8866 6.7766L6.52336 13.1398H4.4707ZM10.4959 7.11469L10.1578 6.76453L10.846 7.45277L10.4959 7.11469Z"
                    fill="white"
                />
            </svg>
        </div>
    )
}

export default EditCirleIcons
